import Container from './editable/Container.js';
import Validator from 'validator';
import notification from 'notification-js';
import Input from './editable/Input.js';
import marked from 'marked';
import Pikaday from 'pikaday';
import moment from 'moment';
import ImageUpload from './ImageUpload.js';

export const mapping = ({data, path}) => {
  return {
    posts: data.posts,
    selectedPost: -1
  }
}

export const transform = ({modal, path, updateState}) => {
  return {
    posts: {
      dom: '.blog_editor_post_list',
      callback: function() {
        let postLinks = document.getElementsByClassName('post-link');

        for (let i =0; i < postLinks.length; i++) {
          let title = postLinks[i].getElementsByClassName('title')[0];
          title.onclick = (event) => {
            event.preventDefault();
            this.selectedPost = i;
            updateState(false);
          }

          let deleteButton = postLinks[i].getElementsByClassName('delete-item')[0];
          deleteButton.onclick = (event) => {
            event.preventDefault();
            deletePost(event, this.posts, i, updateState);
          }
        }
      },
      transform: function(post) {
        return `<li class="post-link">
          <a href="#" class="title">${post.title}</a>
          <a href="#" class="delete-item">Delete</a>
          <a href="#" class="date">${post.date}</a>
        </li>`
      }
    },
    selectedPost: function(sel) {
      let fields = document.getElementsByClassName('editor-fields')[0];

      fields.style.display = 'block';
      if (sel > -1) {
        let post = this.posts[sel];
        let editorFields = modal.el.getElementsByClassName('editor-fields')[0];

        let template = `
          <input type="text" name="title" class="title inputField" value="${post.title}">
          <input type="text" name="author" class="author inputField" value="${post.author}">
          <input type="text" name="date" class="date" value="${post.date}">
          <input type="file" class="image-upload" id="new-image" accept=".png,.jpeg,.jpg" style="display:none;"/>
          <textarea name="content" class="blog-content"></textarea>
        `;

        fields.innerHTML = template;

        let inputFields = modal.el.getElementsByClassName('inputField');

        let imageUpload = modal.el.getElementsByClassName('image-upload')[0];

        function uploadImage(editor) {
          var cm = editor.codemirror;
          var stat = editor.getState();
          var options = editor.options;
          imageUpload.click();

          ImageUpload(imageUpload.id, null, (src) => {
            _replaceSelection(cm, stat.image, options.insertTexts.image, src);
          });

          return false;
        }


        let simplemde = new SimpleMDE({
          element: modal.el.getElementsByClassName("blog-content")[0],
          lineWrapping: true,
          previewRender: function(plainText) {
            return marked(plainText); // Returns HTML from a custom parser
          },
          promptURLs: true,
          spellChecker: false,
          toolbar: [
          "bold", "italic", "heading", "|",
          "quote","unordered-list", "ordered-list", "|",
          "link",
          {
            name: "image",
            action: uploadImage,
            className: "fa fa-image",
            title: "Upload Image",
          }, "|",
          "side-by-side", "fullscreen", "|", "guide"
          ]
        });

        const updateTextValue = (key, value) => {
          editorFields.__dirty = true;
          if (post[key] !== value) {
            post[key] = value;
          }

          updateState();
        };

        let dateField = modal.el.getElementsByClassName('date')[0];
        let picker = new Pikaday({
          field: dateField,
          format: 'Do MMM YYYY',
          onSelect: function() {
            updateTextValue('date', this.getMoment().format('Do MMM YYYY'));
          }
        });

        simplemde.codemirror.on("keyup", function(){
          updateTextValue('content', simplemde.value());
        });

        simplemde.codemirror.on("change", function(){
          updateTextValue('content', simplemde.value());
        });

        simplemde.value(post.content);

        for (let i=0; i < inputFields.length; i++) {
          let fieldName = inputFields[i].name;
          this.posts[sel]["edit" + fieldName] = new Input({onBlur: (event) => {
                                                updateTextValue(fieldName, event.target.value)},
                                                element: inputFields[i]});

          inputFields[i].onkeyup = (event) => {updateTextValue(fieldName, event.target.value)};
        }
      } else {
        fields.style.display = 'none';
      }
    }
  }
};

export const loadForm = ({modal, editor, data, path, updateState}) => {
  let addPostButton = modal.el.getElementsByClassName("add-new-post")[0];

  addPostButton.onclick = (event) => {
    addPost(event, editor.posts, updateState);
  }
}

export const addPost = (event, posts, updateState) => {
  event.preventDefault();
  posts.unshift({title: 'Enter title here',
                 date: moment().format("Do MMM YYYY"),
                 author: 'activDS',
                 content: 'New content'});

  updateState();
}

const deletePost = (event, posts, index, updateState) => {
  event.preventDefault();

  if (posts.length > 1) {
    posts.splice(index, 1);
    updateState();
  }
}

export const getData = (currentState, editor) => {
  currentState.selectedPost = editor.selectedPost;

  let posts = {};
  currentState.posts = [];

  editor.posts.forEach((post, index) => {
    let newPost = {};
    newPost.title = post.title;
    newPost.date = post.date;
    newPost.author = post.author;
    newPost.content = post.content;
    currentState.posts.push(newPost);
  });

  return currentState;
}

export default function() {
  let template = `
    <div class="form overflowVertical">
      <div class="blog_editor post-text editor-fields span12" style="display:none;">
      </div>
      <div class="menu">
        <a href="#" class="add-new-post">Add New</a>
        <ul class="blog_editor_post_list list_view">
        </ul>
      </div>
    </div>
  `

  return `<div>
    ${template}
  </div>`;
};

function _replaceSelection(cm, active, startEnd, url) {
	if(/editor-preview-active/.test(cm.getWrapperElement().lastChild.className))
		return;

	var text;
	var start = startEnd[0];
	var end = startEnd[1];
	var startPoint = cm.getCursor("start");
	var endPoint = cm.getCursor("end");
	if(url) {
		end = end.replace("#url#", url);
	}
	if(active) {
		text = cm.getLine(startPoint.line);
		start = text.slice(0, startPoint.ch);
		end = text.slice(startPoint.ch);
		cm.replaceRange(start + end, {
			line: startPoint.line,
			ch: 0
		});
	} else {
		text = cm.getSelection();
		cm.replaceSelection(start + text + end);

		startPoint.ch += start.length;
		if(startPoint !== endPoint) {
			endPoint.ch += start.length;
		}
	}
	cm.setSelection(startPoint, endPoint);
	cm.focus();
}



// WEBPACK FOOTER //
// ./src/editors/Blog.js